import { minBy as _minBy } from 'lodash-es';
import { loadGoogleMaps } from '../plugins/google-maps';
import mapStyles from './_mapStyles';
import { GooglePlaces } from '../plugins/google-places';
import { pushTrackerEvent } from '../_googleTagManager';
import runOnVisible from '../runner-visible';

let locationCount = 0
let markers = [];
const mapCenter = {
  lat: 48.12998369465293,
  lng: 11.571394000830706
};

export class FilterableMap {
  constructor($el, markerUrl, markerLocationUrl) {
    this.$el = $el;
    this.markerUrl = markerUrl;
    this.markerLocationUrl = markerLocationUrl;
    this.markers = [];
    this.Clustermarkers = [];
    this.visible = false;

    /**
     * @type {google.maps.Map|null}
     */
    this.map = null;

    /**
     * @type {google.maps}
     */
    this.googleMaps = null;

    /**
     *
     * @type {GooglePlaces|null}
     */
    this.places = null;

    /**
     * @type {null|google.maps.Marker}
     */
    this.placeMarker = null;

    /**
     * @type {null|google.maps.LatLng}
     */
    this.selectedLocation = null;

    this.suggestionVisibleListener = null;
  }

  /**
   * Adds a marker to the map
   *
   * @param {number} lat
   * @param {number} lng
   * @param {string} locationName
   */
  addMarker(lat, lng, locationName) {
    let marker = new this.googleMaps.Marker({
      position: {
        lat,
        lng
      },
      icon: this.markerUrl,
      map: this.map,
    });

    markers.push(marker);
    this.Clustermarkers.push(marker);
    marker.set('data-card', `${locationCount}`);
    ++locationCount;

    const markerIcon = document.querySelector('.locations-catalog');

    const listener = marker.addListener('click', (item) => {
      pushTrackerEvent('clickLocationMarker', {
        location: locationName,
      });

      if (markerIcon) {
        let activeClass = document.querySelector('.locations-catalog__item.is-active');
        let activeMarker = marker.get('data-card');

        Array.from(markers).map(item => {
          item.setIcon(markerIcon.getAttribute('data-marker'));
          item.setZIndex(1)
        });

        marker.setIcon(markerIcon.getAttribute('data-marker-active'));
        marker.setPosition({lat: lat, lng: lng});
        marker.setZIndex(999)

        if (activeClass) {
          activeClass.classList.remove('is-active');
        }

        document.querySelector(`.locations-catalog__item[data-card="${activeMarker}"]`).classList.add('is-active');

        if (window.innerWidth < 767) {
          const pageHeader = document.querySelector('.page-header').scrollHeight;

          window.scroll({
            behavior: 'smooth',
            left: 0,
            top: document.querySelector(`.locations-catalog__item.is-active`).offsetTop - pageHeader - 20
          });
        } else {
          const pageHeader = document.querySelector('.page-header').scrollHeight;
          const container = document.querySelector('.locations-catalog__items');
          const activeElement = document.querySelector('.locations-catalog__item.is-active');

          if (container && activeElement) {
            window.scroll({
              behavior: 'smooth',
              left: 0,
              top: document.querySelector(`.locations-catalog__items`).offsetTop - pageHeader - 20,
            });

            const containerRect = container.getBoundingClientRect();
            const activeElementRect = activeElement.getBoundingClientRect();
            const scrollTop = activeElementRect.top - containerRect.top;

            container.scrollTo({
              behavior: 'smooth',
              top: container.scrollTop + scrollTop
            });
          }
        }
      }
    });

    const self = this;
    Array.from(document.querySelectorAll('.locations-catalog__item')).map(item => {
      item.onclick = function(e) {
        if (e.target.classList.contains('fa-comment-info')) {
          return;
        }

        const activeClass = document.querySelector('.locations-catalog__item.is-active');
        let getLat = item.getAttribute('data-lat');
        let getLng = item.getAttribute('data-lng');

        pushTrackerEvent('clickLocationMarker', {
          location: item.querySelector('.leaf__body h3').textContent.trim()
        });

        if (activeClass) {
          activeClass.classList.remove('is-active');
        }

        item.classList.add('is-active');

        Array.from(markers).map(item => {
          if (item.getPosition().lat() === parseFloat(getLat) && item.getPosition().lng() === parseFloat(getLng)) {
            item.setIcon(markerIcon.getAttribute('data-marker-active'));
            item.setPosition({
              lat: parseFloat(this.getAttribute('data-lat')),
              lng: parseFloat(this.getAttribute('data-lng')),
            });
            item.setZIndex(999);
          } else {
            item.setIcon(markerIcon.getAttribute('data-marker'));
            item.setZIndex(1);
          }
        });

        self.map.setZoom(11);
        const bounds = self.map.getBounds();
        const markerPosition = new google.maps.LatLng(parseFloat(getLat), parseFloat(getLng));

        if (!bounds.contains(markerPosition)) {
          self.map.panTo(markerPosition);
        }};
    });

    const createdMarker = {
      marker,
      listener,
    };

    this.markers.push(createdMarker);

    return createdMarker;
  }

  /**
   * Removes a marker from the map
   *
   * @param {{ marker: google.maps.Marker, listener: google.maps.MapsEventListener }} createdMarker
   */
  removeMarker(createdMarker) {
    if (this.googleMaps == null) {
      return;
    }

    const { marker, listener } = createdMarker;

    marker.setMap(null);

    this.googleMaps.event.removeListener(listener);
  }

  clearMarkers() {
    for (let i = 0; i < this.markers.length; i++) {
      this.removeMarker(this.markers[i]);
    }

    for (let i = 0; i < this.Clustermarkers.length; i++) {
      this.removeMarker(this.markers[i]);
    }

    this.markers.length = 0;
    this.Clustermarkers.length = 0;
    this.Clustermarkers = [];

    locationCount = 1
    markers.length = 0;
    markers = [];
  }

  showMap() {
    return new Promise(async (resolve) => {
      if (this.visible) {
        return resolve();
      }

      runOnVisible(this.$el[0], async () => {
        const google = await loadGoogleMaps();
        this.googleMaps = google.maps;

        this.map = new this.googleMaps.Map(this.$el[0], {
          center: mapCenter,
          zoom: 10,
          mapTypeControl: false,
          styles: mapStyles,
        });

        const idleListener = this.map.addListener('idle', () => {
          resolve();

          this.googleMaps.event.removeListener(idleListener);
        });
      })

      this.visible = true;
    });
  }

  enableAutocomplete(input) {
    this.places = new GooglePlaces(this.googleMaps);
    this.places.startAutocomplete(input, this.map);
    this.places.addPlaceChangedListener(this.onPlaceChanged.bind(this));
    this.places.addPlaceSuggestionToggleListener(this.onSuggestionToggle.bind(this));
  }

  /**
   * @param {google.maps.places.PlaceResult} place
   */
  onPlaceChanged(place) {
    pushTrackerEvent('selectPlaceSuggestion', {
      suggestion: {
        place_id: place.place_id,
        name: place.name,
        address: place.formatted_address,
      },
    });

    // if (this.placeMarker === null) {
    this.placeMarker?.setMap(null);
    this.placeMarker = new this.googleMaps.Marker({
      position: place.geometry.location,
      map: this.map,
      animation: this.googleMaps.Animation.DROP,
      icon: this.markerLocationUrl,
    });

    this.selectedLocation = place.geometry.location;

    function haversine_distance(lat, lng) {
      var R = 6371; // Radius of the Earth in miles
      var rlat1 = place.geometry.location.lat() * (Math.PI / 180); // Convert degrees to radians
      var rlat2 = lat * (Math.PI / 180); // Convert degrees to radians
      var difflat = rlat2 - rlat1; // Radian difference (latitudes)
      var difflon = (lng - place.geometry.location.lng()) * (Math.PI / 180); // Radian difference (longitudes)

      var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
      return d.toFixed(2);
    }

    const locationsCatalog = document.querySelectorAll('.locations-catalog__item');

    if (locationsCatalog) {
      locationsCatalog.forEach(function (item) {
        let lat = item.getAttribute('data-lat');
        let lng = item.getAttribute('data-lng');
        let spanTag = item.querySelector('.leaf__body p span');

        if (spanTag) {
          item.setAttribute('data-number', haversine_distance(lat, lng));
          let unit = 'Km';

          if (haversine_distance(lat, lng).startsWith(0)) {
            unit = 'Meter';
          }

          if (spanTag.querySelector('.meters')) {
            spanTag.querySelector('.meters').remove();
          }

          const conn = document.createElement('span');
          conn.classList.add('meters');
          conn.innerHTML = `${haversine_distance(lat, lng)} ${unit} entfernt | `;

          spanTag.insertBefore(conn, spanTag.firstChild);
        }
      });
    }

    const container = document.querySelector('.locations-catalog__items');
    const divs = Array.from(container.getElementsByClassName('locations-catalog__item'));

    divs.sort((a, b) => {
      const numA = parseInt(a.getAttribute('data-number'));
      const numB = parseInt(b.getAttribute('data-number'));

      return numA - numB;
    });

    divs.forEach(div => container.appendChild(div));

    if (this.focusOnResults() === false) {
      this.map.panTo(place.geometry.location);
      this.map.setZoom(11);
    }
    // }
  }

  addSuggestionVisibleListener(callback) {
    this.suggestionVisibleListener = callback;
  }

  onSuggestionToggle(visible) {
    this.suggestionVisibleListener?.(visible);
  }

  hideMap() {
    if (this.visible === false) {
      return;
    }

    this.clearMarkers();
    this.$el[0].innerHTML = '';

    this.visible = false;
  }

  getDistanceBetween(positionA, positionB) {
    return this.googleMaps.geometry.spherical.computeDistanceBetween(positionA, positionB);
  }

  getClosestMarker() {
    return _minBy(this.markers, ({ marker }) => {
      return this.getDistanceBetween(marker.getPosition(), this.selectedLocation);
    });
  }

  getCloseMarkers(maxDistance) {
    return this.markers.filter(({ marker }) => {
      return this.getDistanceBetween(marker.getPosition(), this.selectedLocation) < maxDistance * 1000;
    });
  }

  focusOnMarkers() {
    return this.focusPositions(
      this.markers.map(({ marker }) => {
        return marker.getPosition();
      }),
    );
  }

  focusOnResults() {
    if (this.focusOnCloseMarkers()) {
      return true;
    }

    return this.focusOnClosestMarker();
  }

  focusOnClosestMarker() {
    const { marker: closestMarker } = this.getClosestMarker();
    // kann wieder aktiviert werden, wenn man nicht aktueller Standort und Kliniken im Viewport zusehen sein soll.
    // const markerDistance = this.getDistanceBetween(closestMarker.getPosition(), this.selectedLocation);
    // if (markerDistance > 50) {
    //   return false;
    // }

    return this.focusPositions([
      this.selectedLocation,
      closestMarker.getPosition(),
    ]);
  }

  focusOnCloseMarkers() {
    const maxDistance = 25;
    const closeMarkers = this.getCloseMarkers(maxDistance);
    if (closeMarkers.length <= 0) {
      return false;
    }

    return this.focusPositions([
      this.selectedLocation,
      ...closeMarkers.map(({ marker }) => marker.getPosition()),
    ]);
  }

  focusPositions(positions) {
    if (positions.length === 0) {
      return false;
    }

    if (positions.length === 1) {
      this.map.panTo(positions[0]);
      this.map.setZoom(13);

      return true;
    }

    const bounds = new this.googleMaps.LatLngBounds();
    for (const position of positions) {
      bounds.extend(position);
    }

    this.map.fitBounds(bounds);

    return true;
  }


  getOnlyMap() {
    return this.map;
  }

  getMarkers() {
    return this.Clustermarkers;
  }
}
